import { render, staticRenderFns } from "./messageTipModal.vue?vue&type=template&id=1c4a22a8&scoped=true"
import script from "./messageTipModal.vue?vue&type=script&lang=js"
export * from "./messageTipModal.vue?vue&type=script&lang=js"
import style0 from "./messageTipModal.vue?vue&type=style&index=0&id=1c4a22a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4a22a8",
  null
  
)

export default component.exports